// Vendors
import { FeatureFlagsPlatformsEnumeration } from '@gruposantander/opbpay-ui-core-models';
// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';

const FEATURE_FLAGS_SERVICE_ENDPOINT = {
  ...GIL_API_CHANNEL,
  absoluteUrl: `https://api.${window.ENVIRONMENT}.wp.openbankpay.com/cf-api-feature-flag/v1/ce944fac55ceed47a1db07090614c7fd/feature-flags`,
  queryParams: {
    bank: 'CF_MC',
    platform: FeatureFlagsPlatformsEnumeration.LEN_ONB,
  },
};

export { FEATURE_FLAGS_SERVICE_ENDPOINT };
